import React from 'react';
import ProductCard from '../components/ProductCard';
import { shopProducts } from '../data/products';

export default function ProductsPage() {
  return (
    <>
      <div className="page-header">
        <span className="badge">Full Catalog</span>
        <h1>All Products</h1>
        <p>Every print currently in stock, ready to ship.</p>
      </div>

      <section className="catalog-section" style={{ marginTop: 0 }}>
        <div className="product-grid">
          {shopProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </>
  );
}